import React, { useContext, useEffect, useState } from 'react';

import { useMediaQuery } from 'react-responsive';
import { useTranslation } from 'react-i18next';
import { useQuery } from '@tanstack/react-query';
import classNames from 'classnames';

import CandidateSourceTag from './CandidateSourceTag';
import FavStatus from '../../Header/Search/FavStatus';
import CandidateFavorites from '../../Jobs/MyJobs/JobDetails/CandidateFavorites';
import DotMenu from '../../../ApplicationBadge/DotMenu';
import ApplicationBadge from '../../../ApplicationBadge';

import classes from './styles.module.scss';
import {
  getTimezoneDate,
  getTimezoneTime,
} from '../../../../helpers/timezones';
import closeIcon from '../../../../assets/images/modals/close.svg';
import AdminService from '../../../../services/AdminService';
import UserService from '../../../../services/UserService';
import { CandidatesContext } from '../../../../context/CandidatesContext';
import { UiContext } from '../../../../context/UiContext';
import getResizedImageUrl from '../../../../helpers/getResizedImageUrl';
import { useUserStore } from '../../../../store';

const red = [
  ['New', 'Rejected'],
  ['New', 'Declined'],
  ['Screen', 'Rejected'],
  ['Screen', 'Incomplete'],
  ['Interview', 'Rejected'],
  ['Offer', 'Rejected'],
  ['Offer', 'Declined'],
  ['Interview', 'Declined'],
  ['ClientInterview', 'Rejected'],
  ['ClientInterview', 'Declined'],
  ['ClientSubmit', 'Rejected'],
  ['Onboard', 'NoShow'],
  ['Onboard', 'Declined'],
  ['Onboard', 'Rejected'],
  ['Onboard', 'StartDeclined'],
  ['Screen', 'Failed'],
];

const yellow = [
  ['Interview', 'Canceled'],
  ['Interview', 'ChangeRequested'],
  ['Offer', 'Countered'],
  ['Onboard', 'ChangeRequested'],
  ['Onboard', 'Canceled'],
  ['Onboard', 'StartCanceled'],
  ['ClientInterview', 'Canceled'],
  ['ClientInterview', 'PendingFeedback'],
  ['ClientSubmit', 'ClientNeedsInfo'],
  ['ClientSubmit', 'PendingFeedback'],
];

const black = [
  ['Screen', 'Requested'],
  ['Interview', 'Scheduled'],
  ['Interview', 'Rescheduled'],
  ['Interview', 'Accepted'],
  ['Interview', 'InProgress'],
  ['Offer', 'Offered'],
  ['Offer', 'CounterAccepted'],
  ['Onboard', 'Scheduled'],
  ['Onboard', 'Rescheduled'],
  ['ClientInterview', 'ClientAcceptedClientInterview'],
  ['ClientInterview', 'JobseekerAcceptedClientInterview'],
  ['ClientInterview', 'BothAcceptedClientInterview'],
  ['ClientInterview', 'Reinstated'],
  ['ClientSubmit', 'ClientViewed'],
];

const green = [
  ['Screen', 'Passed'],
  ['Screen', 'Completed'],
  ['Interview', 'Passed'],
  ['Offer', 'Accepted'],
  ['Onboard', 'Onboarded'],
  ['Onboard', 'StartDateSet'],
  ['Onboard', 'Joined'],
  ['Onboard', 'Accepted'],
  ['Onboard', 'StartConfirmed'],
  ['ClientInterview', 'Passed'],
  ['ClientInterview', 'Accepted'],
  ['ClientSubmit', 'Pending'],
  ['ClientInterview', 'InterviewRequested'],
];

const getSelectorColorClass = (status, subStatus) => {
  if (!status || !subStatus) {
    return null;
  }

  const exceptions = {
    Onboard: {
      StartDateSet: 'black',
    },
  };

  if (exceptions[status] && exceptions[status][subStatus]) {
    return classes[exceptions[status][subStatus]];
  }

  switch (true) {
    case !!red.find((stat) => status === stat[0] && subStatus === stat[1]):
      return classes.red;
    case !!yellow.find((stat) => status === stat[0] && subStatus === stat[1]):
      return classes.yellow;
    case !!black.find((stat) => status === stat[0] && subStatus === stat[1]):
      return classes.black;
    case !!green.find((stat) => status === stat[0] && subStatus === stat[1]):
      return classes.green;
    default:
      return null;
  }
};

export default function CandidateHeader({
  candidate,
  refetch,
  jobApplication,
  job,
  isModal,
  isVisible,
  handleClose,
  event,
  careerInfo,
}) {
  console.log('careerInfo', careerInfo);

  const isClient = useUserStore((state) => state.isClient);
  const [currentStep, setCurrentStep] = useState('');
  const [currentSubStatus, setCurrentSubStatus] = useState('');
  const [isFinished, setIsFinished] = useState(false);
  const screeningAvailable = useUserStore((state) => state.screeningAvailable);

  const { t } = useTranslation();

  const isTabletOrMobile = useMediaQuery({ query: '(max-width: 1024px)' });

  const { data: me } = useQuery({
    queryKey: ['me'],
    queryFn: UserService.getMe,
  });

  const isEvent = event !== null && event !== undefined;

  const activeInteview = event;

  console.log('activeInteview', activeInteview);
  console.log('event', event);
  console.log('header candidate', candidate);

  const interviewDate = !activeInteview?.interviewDate
    ? ''
    : getTimezoneDate(
        activeInteview?.interviewDate,
        me.userProfile.timezone,
        activeInteview?.startTime
      )[0]?.toLocaleDateString();

  const startTime = !activeInteview?.startTime
    ? ''
    : getTimezoneTime(activeInteview?.startTime, me.userProfile.timezone);
  const endTime = !activeInteview?.endTime
    ? ''
    : getTimezoneTime(activeInteview?.endTime, me.userProfile.timezone);

  const isJobUnpublished = job?.status === 'UnPublished';

  function translateStep(step) {
    if (step === 'ClientSubmit') {
      return t(`common.jobApplicationStatuses.New`);
    }

    if (step === 'ClientInterview') {
      return t(`common.jobApplicationStatuses.Interview`);
    }
    return step;
  }

  let steps = ['New', 'Interview', 'Offer', 'Onboard'];

  if (
    (job?.assignedAssessments?.length ||
      jobApplication?.assignedAssessments?.length) &&
    screeningAvailable
  ) {
    steps = ['New', 'Screen', 'Interview', 'Offer', 'Onboard'];
  }

  if (
    job?.jobPostType === 'External' ||
    jobApplication?.jobPost?.jobPostType === 'External'
  ) {
    steps = [
      'New',
      'Interview',
      'ClientSubmit',
      'ClientInterview',
      'Offer',
      'Onboard',
    ];
  }

  if (
    (job?.jobPostType === 'External' ||
      jobApplication?.jobPost?.jobPostType === 'External') &&
    (job?.assignedAssessments?.length ||
      jobApplication?.assignedAssessments?.length) &&
    screeningAvailable
  ) {
    steps = [
      'New',
      'Screen',
      'Interview',
      'ClientSubmit',
      'ClientInterview',
      'Offer',
      'Onboard',
    ];
  }

  if (isClient) {
    steps = ['ClientSubmit', 'ClientInterview', 'Offer', 'Onboard'];
  }

  const hasPhoto =
    !!candidate?.userProfile?.avatar || !!candidate?.user?.userProfile?.avatar;
  let candidatePhoto;

  if (hasPhoto) {
    candidatePhoto = getResizedImageUrl({
      url: `avatar/${
        candidate?.userProfile?.avatar || candidate?.user?.userProfile?.avatar
      }`,
      width: 220,
    });
  }

  const { setIsFetching, showNotification } = useContext(UiContext);
  const { showIntelCandidateModal } = useContext(CandidatesContext);

  useEffect(() => {
    setCurrentStep(jobApplication?.status);
    setCurrentSubStatus(jobApplication?.subStatus);
  }, [jobApplication]);

  // Calculate distance between two steps
  useEffect(() => {
    const stepElements = document.querySelectorAll(`.${classes.step}`);

    if (!stepElements.length) {
      return;
    }

    const { x: firstStepX } = stepElements[0]?.getBoundingClientRect();
    const { x: secondStepX } = stepElements[1]?.getBoundingClientRect();

    const distance = secondStepX - firstStepX;

    const container = document.querySelector(`.${classes.candidate}`);

    if (container && distance) {
      container.style.setProperty('--stepsDistance', `${distance}px`);
    }
  }, [candidate, job, jobApplication, isVisible]);

  // let categories;

  // if (
  //   currentStep === 'Interview' &&
  //   candidate?.jobApplicationInterviews?.length
  // ) {
  //   categories = {
  //     title: t('dashboardComponents.Candidate.CandidateHeader.Interview Date'),
  //     date: getDate(
  //       getTimezoneDate(
  //         candidate.jobApplicationInterviews[
  //           candidate.jobApplicationInterviews.length - 1
  //         ].interviewDate,
  //         me?.userProfile?.timezone
  //       )[0]
  //     ),
  //   };
  // }

  // if (
  //   currentStep === 'Onboard' &&
  //   candidate?.jobApplicationOnboardings?.length &&
  //   !candidate?.jobApplicationJoinings?.length
  // ) {
  //   categories = {
  //     title: t('dashboardComponents.Candidate.CandidateHeader.Onboarding Date'),
  //     date: getDate(
  //       getTimezoneDate(
  //         candidate?.jobApplicationOnboardings[
  //           candidate?.jobApplicationOnboardings.length - 1
  //         ]?.onboardingDate,
  //         me?.userProfile?.timezone
  //       )[0]
  //     ),
  //   };
  // }

  // if (
  //   (currentStep === 'Onboard' && currentSubStatus === 'StartDateSet') ||
  //   (currentStep === 'Onboard' &&
  //     (currentSubStatus === 'ChangeRequested' ||
  //       currentSubStatus === 'Rescheduled') &&
  //     candidate?.jobApplicationJoinings?.length)
  // ) {
  //   categories = {
  //     title: t('dashboardComponents.Candidate.CandidateHeader.Start Date'),
  //     date: getDate(
  //       getTimezoneDate(
  //         candidate?.jobApplicationJoinings?.[
  //           candidate?.jobApplicationJoinings?.length - 1
  //         ]?.joiningDate,
  //         me?.userProfile?.timezone
  //       )[0]
  //     ),
  //   };
  // }

  // if (currentStep === 'Offer' && candidate?.jobApplicationOffers?.length) {
  //   categories = {
  //     title: t('dashboardComponents.Candidate.CandidateHeader.Offer Date'),
  //     date: getDate(
  //       getTimezoneDate(
  //         candidate.jobApplicationOffers[
  //           candidate.jobApplicationOffers.length - 1
  //         ].createdAt,
  //         me?.userProfile?.timezone
  //       )[0]
  //     ),
  //   };
  // }

  // if (
  //   currentSubStatus === 'Joined' ||
  //   currentSubStatus === 'Rejected' ||
  //   currentSubStatus === 'Canceled' ||
  //   currentSubStatus === 'Pending' ||
  //   currentSubStatus === 'InProgress' ||
  //   currentSubStatus === 'Passed' ||
  //   currentSubStatus === 'Onboarded' ||
  //   currentSubStatus === 'StartDeclined' ||
  //   currentSubStatus === 'Withdrawn' ||
  //   currentSubStatus === 'NoShow' ||
  //   currentSubStatus === 'Declined'
  // ) {
  //   categories = null;
  // }

  useEffect(() => {
    if (currentSubStatus === 'Joined') {
      setIsFinished(true);
      return;
    }

    setIsFinished(false);
  }, [currentStep, currentSubStatus]);

  // const editEvent = () => {
  //   if (
  //     candidate?.status === 'Onboard' &&
  //     candidate?.subStatus !== 'Onboarded' &&
  //     !candidate.jobApplicationJoinings?.length
  //   ) {
  //     showSetOnboardingModal({ candidate, refetch });
  //   }
  //   if (candidate?.status === 'Interview') {
  //     showScheduleInterviewModal({ candidate, refetch });
  //   }
  //   if (candidate?.status === 'ClientInterview') {
  //     showScheduleInterviewModal({
  //       candidate,
  //       refetch,
  //       initialContactType: 'Client',
  //     });
  //   }
  //   if (candidate?.status === 'Offer') {
  //     showOfferModal({ candidate, refetch });
  //   }
  //   if (
  //     (candidate?.status === 'Onboard' &&
  //       candidate?.subStatus === 'Onboarded') ||
  //     candidate.jobApplicationJoinings?.length
  //   ) {
  //     showSetJoiningModal({ candidate, refetch });
  //   }
  // };

  const changeJobApplicationStatus = async (jobApplicationId, status, undo) => {
    try {
      setIsFetching(true);

      await AdminService.changeMyJobApplicationStatus({
        jobApplicationId,
        status: status.status,
        subStatus: status.subStatus,
      });
      await refetch();
      const stageTitle = {
        Screen: t(
          'dashboardComponents.Candidate.CandidateHeader.stageTitles.Screening'
        ),
        Interview: t(
          'dashboardComponents.Candidate.CandidateHeader.stageTitles.Interview'
        ),
        ClientSubmit: t(
          'dashboardComponents.Candidate.CandidateHeader.stageTitles.ClientSubmit'
        ),
        ClientInterview: t(
          'dashboardComponents.Candidate.CandidateHeader.stageTitles.ClientInterview'
        ),
        Offer: t(
          'dashboardComponents.Candidate.CandidateHeader.stageTitles.Offer'
        ),
        Onboard: t(
          'dashboardComponents.Candidate.CandidateHeader.stageTitles.Onboarding'
        ),
      };

      if (status.subStatus === 'Hire' || status.subStatus === 'Hold') {
        const titleText =
          status.subStatus === 'Hire'
            ? 'Candidate approved for hire. The recruiter has been notified.'
            : 'Candidate placed On Hold. You can resume review anytime.';
        showNotification({
          text: `${titleText}`,
          undo,
        });
      } else {
        showNotification({
          text: `${t(
            'dashboardComponents.Candidate.CandidateHeader.Candidate successfully moved to'
          )} ${stageTitle[status.status]}`,
          undo,
        });
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsFetching(false);
    }
  };

  const firstName = candidate?.userProfile?.firstName;
  const lastName = candidate?.userProfile?.lastName;

  const isFinishedStatus =
    jobApplication?.subStatus === 'Rejected' ||
    jobApplication?.subStatus === 'Joined' ||
    jobApplication?.subStatus === 'Declined' ||
    jobApplication?.subStatus === 'StartDeclined' ||
    jobApplication?.subStatus === 'Withdrawn' ||
    jobApplication?.subStatus === 'NoShow' ||
    jobApplication?.subStatus === 'Requested' ||
    (isJobUnpublished && jobApplication?.status !== 'Onboard');

  const nameAndLocation = (
    <div className={classes.nameAndLocationContainer}>
      <div className={classes.nameContainer}>
        <h1 className={classes.name}>{`${firstName} ${lastName}`}</h1>
        {candidate?.sourceName && (
          <CandidateSourceTag sourceType={candidate?.sourceName} />
        )}
      </div>
      <h2 className={classes.location}>
        {candidate?.applicantLocation ||
          candidate?.userProfile?.city ||
          candidate?.userProfile?.customLocation ||
          candidate?.user?.userProfile?.customLocation}
      </h2>
    </div>
  );

  return (
    <div
      className={classNames(classes.candidate, {
        [classes.finished]: isFinished,
      })}
      style={{ padding: isModal && '17px 32px 15px' }}
    >
      <button
        type="button"
        className={classes.close}
        onClick={() => {
          handleClose();
        }}
      >
        <img src={closeIcon} alt="close" />
      </button>
      <div className={classes.nameAndLocationContainer}>
        <div className={classes.photoContainer}>
          {hasPhoto ? (
            <img
              src={candidatePhoto}
              alt="canditatePhoto"
              className={classes.photo}
            />
          ) : (
            <div className={classes.noPhoto}>{`${firstName?.[0] || ''}${
              lastName?.[0] || ''
            }`}</div>
          )}
        </div>
        {isTabletOrMobile && (
          <div className={classes.sourceContainer}>
            <div className={classes.nameContainer}>
              <h1 className={classes.name}>{`${firstName} ${lastName}`}</h1>
              <h2 className={classes.location}>
                {candidate?.applicantLocation ||
                  candidate?.userProfile?.city ||
                  candidate?.userProfile?.customLocation}
              </h2>
            </div>

            <CandidateSourceTag sourceType={candidate?.sourceType} />
          </div>
        )}
      </div>
      <div className={classes.spaceBetween}>
        <div className={classes.state}>
          {!isTabletOrMobile && nameAndLocation}

          {jobApplication && (
            <div className={classes.steps}>
              {steps.map((step, i) => (
                <div className={classes.step} key={step}>
                  <div
                    className={classNames(classes.currentStep, {
                      [classes.completed]:
                        i < steps.indexOf(currentStep) ||
                        currentSubStatus === 'Joined',
                      [classes.active]: currentStep === step,
                      [classes.red]:
                        red.find(
                          (stat) =>
                            jobApplication?.status === stat[0] &&
                            jobApplication?.subStatus === stat[1]
                        ) && currentStep === step,
                      [classes.yellow]:
                        yellow.find(
                          (stat) =>
                            jobApplication?.status === stat[0] &&
                            jobApplication?.subStatus === stat[1]
                        ) && currentStep === step,
                      [classes.black]:
                        black.find(
                          (stat) =>
                            jobApplication?.status === stat[0] &&
                            jobApplication?.subStatus === stat[1]
                        ) && currentStep === step,
                      [classes.green]:
                        green.find(
                          (stat) =>
                            jobApplication?.status === stat[0] &&
                            jobApplication?.subStatus === stat[1]
                        ) && currentStep === step,
                    })}
                  >
                    {i >= steps.indexOf(currentStep) &&
                      currentSubStatus !== 'Joined' &&
                      i + 1}
                  </div>
                  <p className={classes.stepName}>{translateStep(step)}</p>
                </div>
              ))}
            </div>
          )}
        </div>

        <div className={classes.settings}>
          <div className={classes.menu}>
            <div>
              {jobApplication && (
                <CandidateFavorites
                  favoritesList={jobApplication?.jobApplicationFavorites}
                  refetch={refetch}
                  jobApplicationId={jobApplication?.id}
                  width={40}
                  height={40}
                  white={jobApplication?.subStatus === 'Joined'}
                />
              )}

              {!jobApplication && !isEvent && (
                <FavStatus candidate={candidate} refetch={refetch} big />
              )}
            </div>
            {jobApplication && (
              <div
                className={classNames(
                  classes.status,
                  getSelectorColorClass(
                    jobApplication?.status,
                    jobApplication?.subStatus,
                    {
                      [classes.disabled]: isFinishedStatus,
                    }
                  )
                )}
              >
                <ApplicationBadge jobApplication={jobApplication} />
              </div>
            )}
            {(jobApplication || candidate) && refetch && (
              <DotMenu
                jobApplication={jobApplication}
                interview={event}
                candidate={candidate}
                changeJobApplicationStatus={changeJobApplicationStatus}
                refetch={refetch}
                editCandidate={() =>
                  showIntelCandidateModal({ candidate: careerInfo, refetch })
                }
              />
            )}
          </div>

          {isEvent &&
            event?.status !== 'Requested' &&
            event?.status !== 'Canceled' && (
              <div className={classes.interviewSlotContainer}>
                <div className={classes.interviewSlotBadge}>
                  <span>
                    Interview Slot : {interviewDate || ''} - {startTime || ''} -{' '}
                    {endTime || ''}
                  </span>
                </div>
              </div>
            )}
        </div>
      </div>
    </div>
  );
}
